<section id="reviews" class="px-5 lg:px-16 py-8 lg:py-12 max-w-6xl mx-auto scroll-mt-28">
    <div class="flex flex-wrap items-end justify-between gap-3">
        <div class="text-left">
            <h2 class="text-2xl lg:text-3xl font-medium text-gray-900">Мислења од купувачи</h2>
            @if (summary && summary.count > 0) {
                <p class="pt-1 flex items-center gap-2 text-gray-700">
                    <app-star-rating [rating]="summary.average" [sizeClass]="'text-xl'"></app-star-rating>
                    <span><strong>{{ formatRating(summary.average) }}</strong> од 5 · {{ reviewCountLabel(summary.count) }}</span>
                </p>
            } @else {
                <p class="pt-1 text-gray-600">Сè уште нема мислења. Ако сте го пробале производот, бидете први.</p>
            }
        </div>
        @if (!showForm && !sent) {
            <button type="button"
                    class="rounded border-2 border-primaryDark px-5 py-2 font-medium text-primaryDark hover:bg-primaryDark hover:text-white transition"
                    (click)="showForm = true">Напиши мислење</button>
        }
    </div>

    @if (sent) {
        <p class="mt-5 rounded bg-green-50 border border-green-200 px-4 py-3 text-left text-green-800" role="status">
            Ви благодариме! Мислењето ќе се појави откако ќе го прегледаме.
        </p>
    }

    @if (showForm && !sent) {
        <form class="mt-5 grid gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4 lg:p-6 text-left lg:grid-cols-2"
              [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <fieldset class="lg:col-span-2">
                <legend class="text-sm font-medium text-gray-800">Оценка</legend>
                <div class="flex gap-1 pt-1" role="radiogroup" aria-label="Оценка">
                    @for (value of ratings; track value) {
                        <button type="button"
                                class="text-3xl leading-none px-0.5"
                                role="radio"
                                [attr.aria-checked]="form.controls.rating.value === value"
                                [attr.aria-label]="value + ' од 5'"
                                [class.text-yellow-500]="value <= form.controls.rating.value"
                                [class.text-gray-300]="value > form.controls.rating.value"
                                (click)="setRating(value)">★</button>
                    }
                </div>
                @if (form.controls.rating.touched && form.controls.rating.invalid) {
                    <p class="text-sm text-red-600">Изберете оценка од 1 до 5 ѕвезди.</p>
                }
            </fieldset>

            <label class="block text-sm font-medium text-gray-800">
                Име
                <input class="mt-1 block w-full rounded border border-gray-300 px-3 py-2 font-normal focus:border-primaryDark focus:outline-none"
                       formControlName="authorName" autocomplete="given-name" maxlength="60">
                @if (form.controls.authorName.touched && form.controls.authorName.invalid) {
                    <span class="text-red-600 font-normal">Внесете име.</span>
                }
            </label>

            <label class="block text-sm font-medium text-gray-800">
                Град <span class="font-normal text-gray-500">(не е задолжително)</span>
                <input class="mt-1 block w-full rounded border border-gray-300 px-3 py-2 font-normal focus:border-primaryDark focus:outline-none"
                       formControlName="city" autocomplete="address-level2" maxlength="60">
            </label>

            <label class="block text-sm font-medium text-gray-800 lg:col-span-2">
                Мислење
                <textarea class="mt-1 block w-full rounded border border-gray-300 px-3 py-2 font-normal focus:border-primaryDark focus:outline-none"
                          formControlName="text" rows="4" maxlength="2000"></textarea>
                @if (form.controls.text.touched && form.controls.text.invalid) {
                    <span class="text-red-600 font-normal">Напишете барем една реченица (најмалку 10 знаци).</span>
                }
            </label>

            <label class="block text-sm font-medium text-gray-800 lg:col-span-2">
                Телефон од нарачката <span class="font-normal text-gray-500">(не е задолжително)</span>
                <input class="mt-1 block w-full rounded border border-gray-300 px-3 py-2 font-normal focus:border-primaryDark focus:outline-none lg:w-1/2"
                       formControlName="phoneNumber" type="tel" inputmode="tel" autocomplete="tel" maxlength="40">
                <span class="block pt-1 font-normal text-gray-500">Само за ознаката „Потврден купувач“. Бројот не се објавува.</span>
            </label>

            <!-- Hidden from people; bots fill every field. -->
            <input class="hidden" formControlName="website" tabindex="-1" autocomplete="off" aria-hidden="true">

            <div class="lg:col-span-2 flex flex-wrap items-center gap-3">
                <button type="submit"
                        class="rounded bg-primaryDark px-6 py-2.5 font-medium text-white hover:bg-primaryDarker transition disabled:opacity-60"
                        [disabled]="sending">{{ sending ? 'Се праќа…' : 'Испрати мислење' }}</button>
                <button type="button" class="text-sm text-gray-600 underline" (click)="showForm = false">Откажи</button>
                @if (failed) {
                    <span class="text-sm text-red-600" role="alert">Мислењето не се испрати. Обидете се повторно.</span>
                }
            </div>
        </form>
    }

    @if (summary && summary.count > 0) {
        <div class="mt-6 grid gap-4 md:grid-cols-2">
            @for (review of visibleReviews; track review.id) {
                <app-review-card [review]="review"></app-review-card>
            }
        </div>
        @if (!showAll && summary.reviews.length > initialCount) {
            <button type="button" class="mt-4 text-primaryDark underline" (click)="showAll = true">
                Прикажи ги сите {{ summary.count }} мислења
            </button>
        }
    }
</section>
